<style lang="scss">
  .upload-action-button {
    margin-top: 16px;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import { persistedFilesStore } from "../../stores";

  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { ToastError } from "@sourcewhale/shared/src/svelte/api/sw-toast-error";
  import { saveFile } from "../../../../../../api/files";
  import { parseResumes } from "../../../../../../api/resumes";
  import { fileToDataUrl } from "../../../../../../utils/files.js";
  import { activeTabStore, selectedProjectIdsStore } from "../../stores";

  let {
    isUploading = $bindable(false),
    progress = $bindable(0),
    errorMessage = $bindable(""),
  } = $props();

  const processFile = async (file) => {
    const data = await fileToDataUrl(file);
    const res = await saveFile(data, file.name);
    return res.fileId;
  };

  const handleUpload = async () => {
    event.preventDefault();

    try {
      if (selectedFilesCount === 0 || isUploading) return;

      isUploading = true;
      errorMessage = "";
      progress = 0;

      const files = $persistedFilesStore;
      const totalFiles = files.length;
      const fileIds = [];
      const filePromises = [];

      files.forEach((file) => {
        const promise = processFile(file)
          .then((fileId) => {
            fileIds.push(fileId);
            progress += Math.round((1 / totalFiles) * 100);
          })
          .catch(() => {
            showToast({
              title: "Error",
              subtitle: `Failed to upload file: ${file.name}`,
              type: "danger",
            });
          });

        filePromises.push(promise);
      });

      await Promise.all(filePromises);

      const body = {
        resumes: fileIds.map((fileId) => ({ fileId })),
        projectIds: $selectedProjectIdsStore,
        origin: window.location.pathname,
        actions: ["createCandidate"],
      };

      await parseResumes(body);
      progress = 100;

      showToast({
        title: "Resume uploaded successfully",
        subtitle: "Resume will be processed shortly",
        type: "success",
      });
      activeTabStore.set("recents");
    } catch (error) {
      if (error instanceof ToastError) {
        error.title = "Failed to upload resume";
        showToast(error);
        return;
      }
      throw error;
    } finally {
      isUploading = false;
      $persistedFilesStore = [];
    }
  };

  const selectedFilesCount = $derived($persistedFilesStore.length);
  const uploadButtonText = $derived(
    selectedFilesCount > 0
      ? `Upload files (${selectedFilesCount})`
      : "Upload files"
  );
</script>

<div class="upload-action-button">
  <Button
    kind="primary"
    size="small"
    disabled={selectedFilesCount === 0}
    onclick={handleUpload}
    class="full-width"
  >
    <Icon class="fa-regular fa-arrow-up-from-bracket" size="small" />
    {uploadButtonText}
  </Button>
</div>
